/* eslint-disable import/prefer-default-export */

export function resetState() {
  return {
    type: 'RESET_STATE',
  };
}
